import { AccountIdentity, AccountJwt } from "@common/domain";
import { createAction, props } from "@ngrx/store";
import { AccountEntity } from "@youm-front/account/domain";
import { Conf2SignInFailureReason } from "../conf2-sign-in-failure";

export const signInSuccess = createAction(
  "[Account] Sign In Success",
  props<{ token: AccountJwt }>()
);
export const signInFailure = createAction(
  "[Account] Sign In Failure",
  props<{ error: string }>()
);

export const conf2SignInFailure = createAction(
  "[Account] Conf2 Sign In Failure",
  props<{ reason: Conf2SignInFailureReason }>()
);

export const guestAccountSignIn = createAction(
  "[Account] Guest Account Sign In",
  props<{ identity: AccountIdentity }>()
);
export const guestAccountSignInSuccess = createAction(
  "[Account] Guest Account Sign In Success",
  props<{ token: AccountJwt }>()
);
export const guestAccountSignInFailure = createAction(
  "[Account] Guest Account Sign In Failure",
  props<{ error: string }>()
);

export const signOut = createAction("[Account] Sign Out");

export const meSuccess = createAction(
  "[Account] Me Success",
  props<{ account: AccountEntity }>()
);
export const meFailure = createAction(
  "[Account] Me Failure",
  props<{ error: string }>()
);
export const meSignOut = createAction("[Account] Me Sign Out");

export const redirectToAuth = createAction("[Account] Redirect To Auth");
